import api from './api';

/**
 * Which optional verticals this deployment runs. Unauthenticated and cached
 * for a minute server-side; the app reads it once at boot.
 */
const featuresService = {
  get: () => api.get('/public/features').then((r) => r.data),
};

export default featuresService;
